import { SxProps } from "@mui/material";

export const sxTypographyTitle: SxProps = {
	fontFamily: 'UnimedSans-Bold',
	textAlign: 'center',
	fontSize: '28px'
};

export const sxTypographySubTitle: SxProps = {
	fontFamily: 'Unimed-Sans',
	textAlign: 'center',
	marginBottom: '30px'
};

export const sxButton: SxProps = {
	borderRadius: 80,
	padding: '12px 32px',
	height: '44px',
	border: 2
};

export const sxButtonRed: SxProps = {
	backgroundColor: 'red'
};

export const sxButtonContained: SxProps = {
	borderRadius: 80,
	padding: '12px 32px',
	height: '44px',
};

export const sxTextButton: SxProps = {
	fontFamily: 'UnimedSans-Bold',
	fontSize: 16
};

export const sxCloseIconButton: SxProps = {
	position: 'absolute',
	right: '24px',
	top: '24px',
	color: '#383838',
	'@media(max-width: 650px)': {
			right: '16px',
			top: '12px'
	}
}

export const sxModal: SxProps = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	maxWidth: '40%',
	minWidth: '250px',
	bgcolor: '#fff',
	borderRadius: '16px',
	border: 'none',
	boxShadow: '0px 4px 100px 0px rgba(56, 56, 56, 0.20)',
	padding: '32px 48px',
	gap: '24px',
	maxHeight: '100vh',
	overflow: 'auto',
}

export const sxButtons: SxProps = {
	width: '100%',
	display: 'flex',
	justifyContent: 'center',
	gap: '20px',
	marginTop: '12px'
}